import supabase from '../supabase/supabase';

export async function getManagedCustomers() {
  const { data, error } = await supabase
    .from('zevi_customers_20260925')
    .select('id,full_name,email,phone,created_at,admin_status')
    .order('created_at', { ascending: false });
  if (error) {
    throw new Error('Customers could not be loaded. Verify the customer table and customer-status migration.');
  }
  return data || [];
}

export async function setCustomerStatus(customerId, status) {
  const { error } = await supabase.rpc('zevi_admin_set_customer_status_20260925', {
    input_customer_id: customerId,
    input_status: status
  });
  if (error) throw new Error('Customer status could not be updated. Verify the customer-status migration and admin permissions.');
}